import { mdiChevronLeft, mdiClose } from '@mdi/js';
import _ from 'lodash';
import React, { useContext } from 'react';
import { formatDate } from '../../../services';
import { MessagingContext } from '../../../services/messaging/context';
import { Tooltip } from '../../base';
import { authorNickname } from '../util';
import * as S from './chat-header.styles';
import { UserAvatar, UserAvatarLogo, UserAvatarLogoContainer } from '../message-list.styles';
import enterLogo from '../icons/enter-services-icon.svg';

interface IChatHeaderProps {
    onBack?: () => void;
}

const getInitials = (name: string): string => {
    if (!name) return '';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
};

const formatCreated = (isoString: string | undefined): string => {
    if (!isoString) return '';
    try {
        return formatDate(isoString, 'MMM d, yyyy h:mm a');
    } catch {
        return '';
    }
};

export const ChatHeader: React.FunctionComponent<IChatHeaderProps> = ({ onBack }) => {
    const context = useContext(MessagingContext);
    const { message } = context;

    const handleCloseClick = (): void => {
        context.onMessageClose && context.onMessageClose();
    };

    const handleBackClick = (): void => {
        onBack && onBack();
    };

    const nickname = authorNickname(message as any);
    const initials = getInitials(nickname);
    const createdFormatted = formatCreated(message?.created);

    return (
        <S.Header>
            {onBack && (
                <S.BackButton onClick={handleBackClick}>
                    <S.BackIcon path={mdiChevronLeft} size={0.83} />
                </S.BackButton>
            )}
            <S.HeaderLabels>
                {message && (nickname || createdFormatted) && (
                    <>
                        {(nickname === 'Enter, Inc.' || nickname === 'Enter Support') ? (
                            <Tooltip direction="top" title={<span>{nickname}</span>}>
                                <UserAvatarLogoContainer>
                                    <UserAvatarLogo src={enterLogo} alt={nickname} />
                                </UserAvatarLogoContainer>
                            </Tooltip>
                        ) : (
                            <Tooltip
                                direction="top"
                                title={<span>{nickname || 'Unknown'}</span>}>
                                <UserAvatar>{initials || '?'}</UserAvatar>
                            </Tooltip>
                        )}
                        <S.HeaderTextBlock>
                            {nickname && <S.CreatedBy>{nickname}</S.CreatedBy>}
                            {createdFormatted && (
                                <S.CreatedDate>Created: {createdFormatted}</S.CreatedDate>
                            )}
                        </S.HeaderTextBlock>
                    </>
                )}
            </S.HeaderLabels>
            <S.CloseButton onClick={handleCloseClick}>
                <S.CloseIcon path={mdiClose} size={0.83} />
            </S.CloseButton>
        </S.Header>
    );
};
